export var LorebookFlow;
(function (LorebookFlow) {
    LorebookFlow["GET_LOREBOOK"] = "GetLorebook";
    LorebookFlow["GET_LOREBOOKS"] = "GetLorebooks";
    LorebookFlow["CREATE_LOREBOOK"] = "CreateLorebook";
    LorebookFlow["UPDATE_LOREBOOK"] = "UpdateLorebook";
    LorebookFlow["SUBMIT_LOREBOOK_MODERATION"] = "SubmitLorebookModeration";
    LorebookFlow["DELETE_LOREBOOK"] = "DeleteLorebook";
    LorebookFlow["CREATE_LOREBOOK_ENTRY"] = "CreateLorebookEntry";
    LorebookFlow["UPDATE_LOREBOOK_ENTRY"] = "UpdateLorebookEntry";
    LorebookFlow["DELETE_LOREBOOK_ENTRY"] = "DeleteLorebookEntry";
    LorebookFlow["ATTACH_LOREBOOK"] = "AttachLorebook";
    LorebookFlow["DETACH_LOREBOOK"] = "DetachLorebook";
    LorebookFlow["IMPORT_LOREBOOK"] = "ImportLorebook";
    LorebookFlow["SUGGEST_FIELD"] = "SuggestField";
    LorebookFlow["REPORT_LOREBOOK"] = "ReportLorebook";
    LorebookFlow["CLONE_LOREBOOK"] = "CloneLorebook";
})(LorebookFlow || (LorebookFlow = {}));
